import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getConfigurations, addConfiguration, updateConfiguration, deleteConfiguration } from "../services/configurationService";
import { Configuration } from "../types";

export const useConfigurations = () => {
  const [configs, setConfigs] = useState<{
    list: Configuration[];
    loading: boolean;
    showDeleted: boolean;
    searchQuery: string;
    page: number;
    rowsPerPage: number;
    openAdd: boolean;
    openEdit: boolean;
    openDelete: boolean;
    currentConfig: Configuration | null;
  }>({
    list: [],
    loading: false,
    showDeleted: false,
    searchQuery: "",
    page: 0,
    rowsPerPage: 5,
    openAdd: false,
    openEdit: false,
    openDelete: false,
    currentConfig: null,
  });

  const fetchConfigurations = async () => {
    setConfigs((prev) => ({ ...prev, loading: true }));
    try {
      const data = await getConfigurations(configs.showDeleted);
      setConfigs((prev) => ({ ...prev, list: data }));
    } catch {
      toast.error("Failed to fetch configurations");
    } finally {
      setConfigs((prev) => ({ ...prev, loading: false }));
    }
  };

  const addConfig = async (conname: string, convalue: number) => {
    try {
      await addConfiguration({ conname, convalue });
      toast.success("Configuration added successfully", { theme: "colored" });
      fetchConfigurations();
    } catch {
      toast.error("Failed to add configuration");
    }
  };

  const editConfig = async (id: string, conname: string, convalue: number) => {
    try {
      await updateConfiguration(id, { conname, convalue });
      // toast.success("Configuration updated successfully", { theme: "colored" });
      fetchConfigurations();
    } catch {
      toast.error("Failed to update configuration");
    }
  };

  const removeConfig = async (id: string) => {
    try {
      await deleteConfiguration(id);
      toast.success("Configuration deleted successfully", { theme: "colored" });
      setConfigs((prev) => ({
        ...prev,
        list: prev.list.filter((c) => c._id.$oid !== id),
      }));
    } catch {
      toast.error("Failed to delete configuration");
    }
  };

  useEffect(() => {
    fetchConfigurations();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configs.showDeleted]);

  return {
    configs,
    setConfigs,
    fetchConfigurations,
    addConfig,
    editConfig,
    removeConfig,
  };
};
